/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [""];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/admin/user-upgrade-subscription-notice/user-upgrade-subscription-notice.component.scss.shim.ngstyle.js.pre-build-optimizer.js